<p-confirm-dialog />
<h3 class="with-manual-link">
  <span i18n="@@mcpServer">MCP-Server</span>
  <app-manual-link href="/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/MCP-Server"></app-manual-link>
</h3>
<div class="d-flex gap-2 mb-2 mt-3">
  <p-button
    size="small"
    i18n-label="@@add-mcp-server-engine"
    label="MCP-Server hinzufügen (Engine)"
    (onClick)="this.openedEditor = undefined; this.openedCreator = 'managed'"
    />
  <p-button
    size="small"
    i18n-label="@@add-mcp-server-external"
    label="MCP-Server hinzufügen (Extern)"
    (onClick)="this.openedCreator = 'external'"
    />
  @if(this.openedCreator === 'managed'){
    <app-mcp-add-edit-managed
      [visible]="this.openedCreator === 'managed'"
      (visibleChange)="this.openedCreator = undefined"
      [edit]="false"
    ></app-mcp-add-edit-managed>
  }
  @if(this.openedCreator === 'external'){
    <app-mcp-add-edit-external
      [visible]="this.openedCreator === 'external'"
      (visibleChange)="this.openedCreator = undefined"
      [edit]="false"
    ></app-mcp-add-edit-external>
  }
</div>

@if(this.openedEditor){
  @if (this.openedEditor.type === 'managed'){
    <app-mcp-add-edit-managed
      [visible]="true"
      (visibleChange)="this.openedEditor = undefined"
      [edit]="true"
      [mcpConfig]="this.openedEditor"
    ></app-mcp-add-edit-managed>
    }@else if (this.openedEditor.type === 'external') {
    <app-mcp-add-edit-external
      [visible]="true"
      (visibleChange)="this.openedEditor = undefined"
      [edit]="true"
      [mcpConfig]="this.openedEditor"
    ></app-mcp-add-edit-external>
  }
}

@if (this.mcpService.mcps.length > 0) {
  <p-table
    dataKey="_id"
    [(selection)]="selectedMcps"
    [value]="this.mcpService.mcps"
    styleClass="p-datatable-sm"
    >
    <ng-template pTemplate="header">
      <tr>
        <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
        <th style="width: 72px"></th>
        <th i18n="@@name">Name</th>
        <th i18n="@@description">Beschreibung</th>
        <th i18n="@@tools">Tools</th>
        <th style="width: 72px;"></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-mcp
      >
      <tr>
        <td class="bot-selection-cell"><p-tableCheckbox [value]="mcp" /></td>
        @if(mcp.type==='managed'){
          <td>
            <p-tag
              severity="info"
              icon="ri-home-4-line"
              [rounded]="true"
              i18n-pTooltip="@@Engine"
              pTooltip="Engine"
              tooltipPosition="left"
              />
          </td>
          <td>{{ mcp.toolName }}</td>
          <td>{{ mcp.description}}</td>
          <td>
            <button
              pButton
              type="button"
              class="p-button-text p-button-plain p-0 no-hover-btn flex align-items-center"
              (click)="menu.toggle($event)"
              style="background: none; border: none; box-shadow: none;"
              >
              <p-tag
                severity="secondary"
                [value]="mcp.allowed_tools.length"
                [rounded]="true"
                class="mr-2"
              ></p-tag>
            </button>
            <p-tieredMenu
              #menu
              [model]="getToolListForMCP(mcp)"
              [popup]="true"
              appendTo="body"
            ></p-tieredMenu>
          </td>
        }
        @else {
        <td>
          <p-tag
            icon="ri-global-line"
            severity="warn"
            [rounded]="true"
            i18n-pTooltip="@@Extern"
            pTooltip="Extern"
            tooltipPosition="left"
            />
        </td>
        <td>{{ mcp.tool.server_label }}</td>
        <td>{{ mcp.tool.server_description}}</td>
        <td>
          <button
            pButton
            type="button"
            class="p-button-text p-button-plain p-0 no-hover-btn flex align-items-center"
            (click)="menu.toggle($event)"
            style="background: none; border: none; box-shadow: none;"
            >
            <p-tag
              severity="secondary"
              [value]="mcp.tool.allowed_tools.length"
              [rounded]="true"
              class="mr-2"
            ></p-tag>
          </button>
          <p-tieredMenu
            #menu
            [model]="getToolListForMCP(mcp)"
            [popup]="true"
            appendTo="body"
          ></p-tieredMenu>
        </td>
      }
      <td style="vertical-align: top;">
        <p-popover
          [dismissable]="true"
          #popover
          appendTo="body"
          >
          <div class="flex flex-column">
            @for (item of contextMenu; track item) {
              <div
                class="flex align-items-center gap-3 py-1 px-2 cursor-pointer popover-hover transition-colors transition-duration-150"
                (click)="item.command(); popover.hide();"
                >
                <i
                  [class]="item.icon"
                  class="text-secondary me-3"
                ></i>
                <span class="text-color">{{ item.label }}</span>
              </div>
            }
          </div>
        </p-popover>
        <p-button
          #button
          (click)="openMenu($event, popover, mcp, button) "
          [rounded]="true"
          severity="secondary"
          styleClass="button-icon"
          icon="ri ri-more-2-fill"
          />
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedMcps.length" [allSelected]="allSelected"
  (selectAll)="toggleAll(true)" (clear)="selectedMcps = []" />
}
